import ScheduleTab from './container'

export default ScheduleTab